import { render, staticRenderFns } from "./SurveyDashboard.vue?vue&type=template&id=1165c3f9&"
import script from "./SurveyDashboard.vue?vue&type=script&lang=js&"
export * from "./SurveyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SurveyDashboard.vue"
export default component.exports